import React from 'react';

export const AdminPageHeader = ({ icon: Icon, title, subtitle, rightContent }) => (
  <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-6 shadow-lg">
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-bold text-white flex items-center">
          {Icon && <Icon className="h-7 w-7 mr-3" />}
          {title}
        </h2>
        {subtitle && <p className="text-blue-100 mt-1 text-sm">{subtitle}</p>}
      </div>
      {rightContent && (
        <div className="flex items-center gap-3">
          {rightContent}
        </div>
      )}
    </div>
  </div>
);
